<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/subscription/" + subscription.id + "/update-ad-spend"'>
        <template #title>Update ad spend on {{ subscription.company.name }}</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Update ad spend for {{ subscription.location_area.name }}</p>
            <p class='text-14 text-grey-900 mt-2'>
                You can use this to add or remove ad spend to a subscription. 
            </p>

            <Select class='mt-4' name='reason'
                v-model:value='value.reason'
                placeholder='Reason'
                label='Reason for ad spend change' 
                :options="[
                    { value: 'Poor performance' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            /> 

            <Input name='amount' class='mt-4'
                v-model:value='value.amount' label='Ad spend to add' />

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">Current balance is {{ $help.dp(parseFloat(subscription.subscription_balance)) }}, 
                    new balance will be {{ $help.dp(parseFloat(subscription.subscription_balance) + parseFloat(value.amount)) }}. 
                    Are you sure you want to do this?</p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update spend
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                value: {
                    reason: null,
                    reason_other: '',
                    amount: 0
                }
            }
        },

        computed: {
            subscription() {
                return this.editingModel
            }
        }
    }
</script>